export default {
  name: "LoginModal",
  props: [],
  data() {
    return {};
  },
  computed: {
    type() {
      return this.$store.state.modalType;
    }
  },
  methods: {},

  mounted() {}
}
